import { formatDate } from './util';

/**
 * This function is to switch between using either the MostRecentClose, or the LessRecentClose.
 * During the trading day, the MostRecentClose is typically from the day before and will work fine.
 * However, after the trading closes sometimes certain stocks such as the S&P500 and the NASDAQ will zero out.
 * This is because the MostRecentClose will be updated to the close that day and not the day before.
 * To counter this we check if the MostRecentCloseDate is the same day as the closing date,
 * and if it is we will use LessRecentClose which by this time will be updated to the day before.
 * All of this is to replace the previously unreliable PrevClose which would without notice switch
 * between the two closing prices.
 * In addition, there is a fun twist for Mutual Funds in which they are calculated on the same
 * day as the closing day, after the close of the day, so we always want to use the PrevClose
 * Price as provided by CloudQuote.
 */
export function getGoodPrevClose(quoteObj) {
	let mostRecentCloseDateCheck = formatDate(quoteObj.MostRecentCloseDate).split('/');
	let chartEndTimeCheck = formatDate(quoteObj.ChartEndTime*1000).split('/');

	if (quoteObj.ExchangePrefixCode && (quoteObj.ExchangePrefixCode.toUpperCase() === 'MF')) {
		return quoteObj.PrevClose;
	}

	if (mostRecentCloseDateCheck[1] === chartEndTimeCheck[1]) {
		return quoteObj.LessRecentClose;
	}
	return quoteObj.MostRecentClose;
}
